import { render } from "./leftNavi.vue?vue&type=template&id=0e22ed2a&scoped=true"
import script from "./leftNavi.vue?vue&type=script&lang=js"
export * from "./leftNavi.vue?vue&type=script&lang=js"

import "./leftNavi.vue?vue&type=style&index=0&id=0e22ed2a&scoped=true&lang=css"

import exportComponent from "/home/king/git/miniapp/northland-bio-miniapp-webclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e22ed2a"]])

export default __exports__